import { render, staticRenderFns } from "./FormBoxCheckbox.vue?vue&type=template&id=951fbdc6&scoped=true&"
import script from "./FormBoxCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormBoxCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FormBoxCheckbox.vue?vue&type=style&index=0&id=951fbdc6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951fbdc6",
  null
  
)

export default component.exports